import axios from '@/plugins/axios'

const baseUrl = process.env.VUE_APP_URL_API

const state = {
  categories: null,
  mediaTypes: null,
  imageUploaded: null,
  imageUploadedError: null,
}

const actions = {
  POST_LOCAL_PHOTO: ({commit}, data) => {
    axios.post(`${baseUrl}/mediaitem`, data)
      .then(function (response) {
        commit('LOCAL_PHOTO', response)
      })
      .catch(function (error) {
        commit('LOCAL_PHOTO_ERROR', error)
      });
  },
  UPDATE_LOCAL_PHOTO: ({commit}, { data, id }) => {
    axios.post(`${baseUrl}/mediaitem/${id}`, data)
      .then(function (response) {
        commit('LOCAL_PHOTO', response)
      })
      .catch(function (error) {
        commit('LOCAL_PHOTO_ERROR', error)
      });
  },
  POST_LOCAL_PHOTO_BULK: ({commit}, data) => {
    axios.post(`${baseUrl}/mediaitem/bulk`, data)
      .then(function (response) {
        commit('LOCAL_PHOTO', response)
      })
      .catch(function (error) {
        commit('LOCAL_PHOTO_ERROR', error)
      });
  },
  DELETE_LOCAL_PHOTO: ({commit}, id) => {
    axios.delete(`${baseUrl}/mediaitem/${id}`)
      .then(function (response) {
        commit('LOCAL_PHOTO', response)
      })
      .catch(function (error) {
        commit('LOCAL_PHOTO_ERROR', error)
      });
  },
}

const mutations = {
  LOCAL_PHOTO(state, response) {
    state.imageUploaded = response
  },
  LOCAL_PHOTO_ERROR(state, error) {
    state.imageUploadedError = error
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
